const localStorage = {};

export const getLocalStorage = (key) => {

    let value;
    if(typeof(window) === "undefined"){
        value = localStorage[key];
    }
    else {
        value = window.localStorage[key];
    }

    try{
        value = JSON.parse(value);
    }
    catch {

    }

    return value;
}

export const setLocalStorage = (key, value) => {
    if(typeof(value) !== "string"){
        value = JSON.stringify(value);
    }

    if(typeof(window) === "undefined"){
        localStorage[key] = value;
        return;
    }

    return window.localStorage.setItem(key, value);
}

const sessionStorage = {};

export const getSessionStorage = (key) => {

    let value;
    if(typeof(window) === "undefined"){
        value = sessionStorage[key];
    }
    else {
        value = window.sessionStorage[key];
    }

    try{
        value = JSON.parse(value);
    }
    catch {

    }

    return value;
}

export const setSessionStorage = (key, value) => {
    if(typeof(value) !== "string"){
        value = JSON.stringify(value);
    }

    if(typeof(window) === "undefined"){
        sessionStorage[key] = value;
        return;
    }

    return window.sessionStorage.setItem(key, value);
}

export const getCityStateZipFromLocationString = (locationString) => {
    if (locationString) {
        const locationStringParts = locationString.split('--');
        if (locationStringParts.length > 2) {
            return {
                city: locationStringParts[0],
                state: locationStringParts[1],
                postalCode: locationStringParts[2],
            }
        }
    }

    return null;
}

const hexColorRegex = /#[\da-f]{6,8}/gmi;

export const extractColors = (stringValue) => {
    if(!stringValue){
        return [];
    }
    return stringValue.match(hexColorRegex) || [];
}

export const getCookie = (name) => {
    return document.cookie.split(";").map(cookie => {
        const cookieKvp = cookie.split("=");
        return {
            name: cookieKvp[0].trim(),
            value: cookieKvp[1]
        }
    }).filter(cookie => cookie.name == name)[0];
}

export const getGAClientId = () => {
    try {
        const trackingCookie = getCookie("_ga");
        if(trackingCookie){
            const trackingCookieSplit = trackingCookie.value.split(".");
            return trackingCookieSplit[trackingCookieSplit.length - 2] + "." + trackingCookieSplit[trackingCookieSplit.length - 1];
        }
    } catch (e) {
        return '';
    }
};

export const getKenshooId = () => {
    try{
        const urlParams = new URLSearchParams(window.location.search);
        const kenshooId = urlParams.get('kenshooid');
        return kenshooId;
    } catch(e) {
        return '';
    }
}

const externalSlugs = [
    "/crossmod",
    "/studio",
    "/newsroom"
];

export const isSlugInternal = (slug) => {
    slug = (slug || "").toLowerCase();

    if(slug[0] !== "/"){
        slug = "/" + slug;
    }

    for(let i = 0; i < externalSlugs.length; i++){
        if(slug.indexOf(externalSlugs[i]) === 0){
            return false;
        }
    }

    return true;
}


const internalUrlVariants = [
    "/",
    "www.claytonhomes.com",
    "claytonhomes.com",
    "http://www.claytonhomes.com",
    "https://www.claytonhomes.com",
    "http://claytonhomes.com",
    "https://claytonhomes.com"
];

export const getUrlTarget = (url) => {
    return isUrlSameDomain(url) ? '_self' : '_blank';
}

export const isUrlSameDomain = (url) => {
    url = (url || "").toLowerCase();

    for(let i = 0; i < internalUrlVariants.length; i++){
        if(url.indexOf(internalUrlVariants[i]) == 0){
            return true;
        }
    }

    return false;
}

export const isUrlInternal = (url) => {
    if(isUrlSameDomain(url)){
        return isSlugInternal(getSlug(url));
    }

    return false;
}

export const getSlug = (slug) => {
    slug = (slug || "").toLowerCase();
    slug = slug.replace("//", ":");

    const slashIndex = slug.indexOf("/");
    return slug.substring(slashIndex);
}

export const scrollToElement = (element, yOffset = 0) => {
    if(element){
        window.scrollTo({top: window.pageYOffset + element.getBoundingClientRect().top + yOffset, behavior: "smooth"});
    }
}